<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12)
      h3.white--text.font-weight-power-ball {{ `STEP 1: WHITE BALL (${$t('power-ball.select-amount-white-ball')})` }}
    v-col(
      v-for='(item,i) in numberItems'
      :key='i'
      style="max-width:10%; flex: 0 0 10%"
      align="center"
    ) 
      v-btn-toggle.d-block.ma-1(
        :value="selectAmount"
        multiple
        style="border-radius:10px; border"
        color='var(--btn-activate-whiteball-v2)'
      ).buttonStake
        v-btn(
          block
          color="white"
          style="padding:0; border-width:inherit; height:100%;"
          :value="i+1"
          :disabled='isDisable()'
          @click="clickValue($event,i+1)"
        )
          h3 {{ item }}
</template>
<script> 
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }, 
  },
  data: () => ({
    selectAmount:[],
  }),
  computed: {
    numberItems () {
      return 69
    },
  },
  watch: {
    selectAmount (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.selectAmount = val 
    },
  },
  mounted () {
      this.selectAmount = this.value 
  },
  methods: {
    clear () {
      setTimeout(()=>{
        this.selectAmount = []
      },100) 
    },
    clickValue (_,val) { 
      let items = this.selectAmount
      const indexSplice = items.findIndex(x=>x===val)
      if(indexSplice>-1) {
        items.splice(indexSplice,1)
        return
      }
      if(this.selectAmount.length >= 5) {
        items.splice(-1)
      }
      items.push(val)
      this.selectAmount = items
    },
    isDisable () {
      return this.selectAmount.length >= 6
    }, 
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 960px) {
  h3{
    font-size: 0.8rem;
  }
}
@media only screen and (max-width: 1260px) {
  .buttonStake {
    width: min(7vw ,100px);
    height: min(7vw ,100px);
  }
}
@media only screen and (min-width: 1261px) {
  .buttonStake {
    width: min(4vw ,60px);
    height: min(4vw ,60px);
  }
}
</style>